<template>
  <div class="ui-box-item">
    <titleComponents :show.sync="show" name="孕妇数据"></titleComponents>
    <div class="itemInfo-detail" v-show="show">
      <el-row style="margin-top:15px">
        <el-col :span="5">
          <div class="ui-label">姓名：{{data.username}}</div>
        </el-col>
        <el-col :span="5">
          <div class="ui-label">年龄：{{data.age?data.age+'岁':''}}</div>
        </el-col>
        <el-col :span="5">
          <div class="ui-label">孕周：{{data.week}}</div>
        </el-col>
        <el-col :span="5">
          <div class="ui-label">手机号：{{data.phone}}</div>
        </el-col>
      </el-row>
      <el-row style="margin-top:15px">
        <el-col :span="5">
          <div class="ui-label">监护开始时间：{{data.tbStartTime}}</div>
        </el-col>
        <el-col :span="5">
          <div class="ui-label">监护结束时间：{{data.tbEndTime}}</div>
        </el-col>
        <el-col :span="5">
          <div class="ui-label">监护时长：{{calculateTimeDifference(data.tbStartTime,data.tbEndTime)}}</div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import titleComponents from '@/components/mother/title'
export default {
  name: 'baseInfo',
  props: {
    data: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      show: true
    }
  },
  created () {

  },
  computed: {

  },
  methods: {
    calculateTimeDifference (startTime, endTime) {
      // 确保输入是Date对象
      const start = new Date(startTime);
      const end = new Date(endTime);

      // 计算时间差（毫秒）
      let difference = end - start;

      // 处理结束时间早于开始时间的情况
      if (difference < 0) {
        difference = -difference;
      }

      // 计算小时、分钟和秒
      const hours = Math.floor(difference / (1000 * 60 * 60));
      difference -= hours * (1000 * 60 * 60);
      const minutes = Math.floor(difference / (1000 * 60));
      difference -= minutes * (1000 * 60);
      const seconds = Math.floor(difference / 1000);
      return `${hours}小时${minutes}分钟${seconds}秒`;
    },
  },
  components: {
    titleComponents
  }
}
</script>

<style lang="scss" scoped>
.ui-box-item {
  margin: 20px 24px 0;
  background: rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: calc(100% - 48px);
  .itemInfo-detail {
    border-top: 1px solid #e5e5e5;
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
    .ui-title {
      font-weight: 400;
      font-size: 16px;
      color: #000000;
      line-height: 24px;
    }
    .ui-label {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      line-height: 22px;
    }
    .ui-button {
      width: 60px;
      height: 27px;
      background: #3d7fff;
      border-radius: 2px;
      font-weight: 400;
      font-size: 11px;
      color: #ffffff;
      line-height: 27px;
      text-align: center;
    }
  }
}
</style>
     